module.exports = __webpack_public_path__ + "static/img/02.9e19515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/03/02.jpg
// module id = UUzf
// module chunks = 0